import header from "./grundriss-einfamilienhaus-modern.webp";
import section1 from "./exchange-of-keys.jpg";
import section2 from "./floorplan-of-a-house.jpg";
import section3 from "./person-with-drawing-of-a-floorplan.jpg";
import section4 from "./grundriss-einfamilienhaus-land.jpg";

export { header, section1, section2, section3, section4 };
